module.exports = __webpack_public_path__ + "static/media/goldenGateFront.efbbbca9.jpg";